export enum ContentGroupViewEvent {
  activate = 'activate',
  deactivate = 'deactivate',

  /**
   * Clicked on content group button (tab or accordion item)
   */
  clickContentGroupButton = 'clickContentGroupButton',
}
